const LineAxisTick = (props: any) => {
  const { y, payload } = props;

  const handleRef = (node: SVGTextElement | null) => {
    if (!node || !payload?.value) return;

    const bbox = node.getBBox();
    const textWidth = bbox.width;
    const padding = 8;

    node.setAttribute("dx", `${textWidth + padding}`);
  };

  return (
    <text ref={handleRef} {...props} y={y - 10} fontFamily="Arial" fontWeight={500} fontSize={15} textAnchor="end">
      <tspan>{payload.value}</tspan>
    </text>
  );
};

export default LineAxisTick;
